<template>
  <DelDialog width="650px" :dialogVisible="uploadFileVisible" @handleClose="handleCancel"
             @handleConfirm="handleConfirm">
    <template #title>{{$t('intelligentTranslation.Continuetoupload')}}</template>
    <el-upload class="upload-demo" drag action multiple :limit="maxFileNum" :accept="acceptStr"
               :file-list="uploadFileList" :show-file-list="false" :on-change="uploadChange"
               :on-exceed="handleExceed" :http-request="uploadSectionFile"
               :before-upload="beforeUploadFile">
      <div class="emptyBox" v-if="uploadFileList.length ? false: true">
        <img style="width:150px;" src="../images/sc_img.png" />
        <div class="el-upload__text">
          {{$t('project.supportFormat', [tip])}}
          <em style="display:block">{{$t('newProjectV2.singleFileSize', [$supportFileSuffixes().maxSize, maxFileNum])}}</em>
        </div>
      </div>

      <div v-else class="file-upload-list">
        <el-table border :data="uploadFileList" :height="tableHight"
                  header-row-class-name="customHeader">
          <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="55">
            <template slot-scope="{ $index }">
              {{$index + 1}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('newProjectV2.name')" align="center" prop="name"
                           :show-overflow-tooltip='true'>
            <template slot-scope="{ row }">
              <img :src="row.imgSrc" height="15" style="vertical-align: middle;" />
              <span>{{row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('newProjectV2.progress')" align="center">
            <template slot-scope="{ row }">
              <el-progress :stroke-width="8" :status="row.exception"
                           :percentage="isNaN(row.percentage) ? 100 : row.percentage">
              </el-progress>
            </template>
          </el-table-column>
          <el-table-column :label="$t('newProjectV2.operate')" align="center" class-name="operate">
            <template slot-scope="{ $index }">
              <el-tooltip class="item" effect="dark" :content="$t('newProjectV2.del')"
                          placement="top">
                <i @click.stop="handleDelete($index)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-upload>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import axios from "axios";
import { getFileLang, getUploadSign } from '@/services/newProjectApi';
import { addProjectFiles } from '@/services/projectDetailsApi';

export default {
  name: 'uploadFile',
  components: {
    DelDialog
  },
  props: {
    uploadFileVisible: {
      type: Boolean
    },
    fileList: {
      type: Array
    },
    createObj: {
      type: Object
    }
  },
  data() {
    return {
      tip: "doc,docx,xls,xlsx,ppt,pptx,txt,pdf,xlf,eml,html,htm,jpg,png,bmp,tiff,dwg,dxf",
      acceptStr: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.pdf,.xlf,.eml,.html,.htm,.jpg,.png,.bmp,.tiff,.dwg,.dxf',  // 支持文件格式
      uploadFileList: [],
      tableHight: '100%',
      host: '',
      formData: new FormData(),
      queryData: {}
    }
  },
  mounted() {
    this.queryData = (JSON.parse(this.$Base64.decode(this.$route.query.key)))
  },
  methods: {
    uploadChange(file) {
      this.uploadFileList.push({
        ...file,
        imgSrc: '',
        path: '',
        source: '',
        obp: false
      });
    },

    handleExceed() {
      this.$message.closeAll();
      this.$message.warning(this.$t('newProjectV2.maxFileNum', [this.maxFileNum]));
    },

    uploadSectionFile(param) {
      if (param.file.obp) {
        return;
      }

      let self = this;
      // 获得上传签名
      getUploadSign().then(({ result }) => {
        self.host = result.host;
        let re = /([^\.\/\\]+)\.([a-z]+)$/i;
        let resultArr = re.exec(param.file.name);
        // 文件类型
        let type = resultArr[2].toLocaleLowerCase();

        // self.uploadFileList.forEach((item, index) => {
        //   if (item.uid === param.file.uid) {
        //     // item.type = type;
        //     item.imgSrc = require(`./assets/images/${type}.png`);
        //     self.$set(self.uploadFileList, index, item);
        //   }
        // });

        let para = {
          ...result,
          key: `${result.keyPrefix}.${type}`,
          file: param.file,
        };
        Reflect.deleteProperty(para, 'keyPrefix');
        Reflect.deleteProperty(para, 'host');

        self.formData = new FormData();
        Object.keys(para).forEach(function (key) {
          self.formData.append(key, para[key]);
        });

        this.getFileHost(param);

      }).catch(() => {
        this.$message.warning(this.$t('newProjectV2.uploadFileFail'));
      });
    },

    getFileHost(param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: progressEvent => {
          const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };

      axios.post(FileController, self.formData, config).then((resp) => {
        let { result } = resp.data;

        // self.getLong(result.fileName, param);

        self.uploadFileList.forEach((item, index) => {
          // 上传文件夹的param和单个上传的param不一样
          if (item.uid === param.file.uid) {
            item.path = result.fileName;
            self.$set(self.uploadFileList, index, item);
          }
        });
      });
    },

    // 检测语言方法
    getLong(path, param) {
      let self = this;
      getFileLang({
        path
      }).then(({ result }) => {
        // 添加源语言字段
        this.uploadFileList.forEach((item, index) => {
          if (item.uid === param.file.uid) {
            item.source = result.sourceLangName || "";
            self.$set(self.uploadFileList, index, item);
          }
        });
      });
    },

    beforeUploadFile(file) {
      let re = /([^\.\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();
      // 文件是否超过大小
      let isLt20M = file.size / 1024 / 1024 > this.$supportFileSuffixes().maxSize;

      let typeFlag = this.$supportFileSuffixes(type).acceptStr;

      let isFileNameLength = file.name.length > 160

      if (!typeFlag) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.onlySupportFormate', [this.$supportFileSuffixes().acceptStr]));
        // 去除最后一个文件
        this.uploadFileList.pop();
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.notSupportEmptyFolder'));
        // 去除最后一个文件
        this.uploadFileList.pop();
        return false;
      }

      this.uploadFileList.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.$message.closeAll();
          this.$message.warning(this.$t('newProjectV2.uploadFileRepeat'));
          this.uploadFileList.pop();
          file.obp = true;
          return false;
        }
      });

      if (isLt20M) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.maxUploadFileSize', [this.$supportFileSuffixes().maxSize]));
        this.uploadFileList.pop();
        file.obp = true;
        return false;
      }
      if (isFileNameLength) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.fileNameLength'));
        this.uploadFileList.pop();
        file.obp = true;
        return false;
      }
      return true;
    },

    handleDelete(index) {
      this.uploadFileList.splice(index, 1);
    },

    handleCancel() {
      this.uploadFileList = [];
      this.$emit('uploadFileCancel');
    },

    async handleConfirm() {
      if (this.uploadFileList.length <= 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.uploadFileTip'));
        return;
      }

      let fileName = false;
      this.uploadFileList.forEach(i => {
        this.fileList.forEach((item) => {
          if (i.name === item.name) {
            fileName = true;
          }
        });
      });

      if (fileName) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.uploadFileRepeat'));
        this.handleCancel();
        return;
      }

      let arr = [];
      this.uploadFileList.forEach(item => {
        arr.push({
          filePath: item.path,
          fileSuffix: /([^\.\/\\]+)\.([a-z]+)$/i.exec(item.name)[2],
          langDesc: this.createObj.langDesc,
          name: item.name
        });
      });

      let param = {
        id: this.queryData.project_id,
        transFileList: arr,
        transModel: 0
      };

      let { success, errorDesc } = await addProjectFiles(param);
      this.$message.closeAll();
      if (!success) {
        this.$message.warning(errorDesc);
        this.handleCancel();
        return;
      }
      this.$message.success(this.$t('projectDetailsV2.uploadFileSuccess'));
      this.handleCancel();
      this.$emit('updateFileList');
    }
  },
  computed: {
    maxFileNum() {
      return this.$supportFileSuffixes().limit - this.fileList.length;
    }
  },
}
</script>

<style lang="less" scoped>
.upload-demo {
  height: 224px;
  .file-upload-list {
    height: 100%;
  }
  /deep/.el-upload {
    width: 100%;
    height: 100%;
    .el-upload-dragger {
      width: 100%;
      height: 100%;
      border: 1px solid #dedede;
    }
    .el-upload__text {
      color: #999;
    }
    img {
      margin-top: 20px;
    }
    em {
      margin-top: 10px;
    }
  }
  /deep/.customHeader {
    th {
      background: #f3f7fe;
      color: #566087;
      font-weight: bold;
    }
  }
  /deep/.el-progress-bar__inner {
    background: linear-gradient(-90deg, #0078fc, #7abcff);
  }
  /deep/.operate {
    .cell {
      display: flex;
      justify-content: center;
    }
  }
  /deep/ i {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("../images/icon-del.png") no-repeat center center;
    &:hover {
      background: url(../images/icon-del-pre.png) no-repeat center center;
    }
  }
}
</style>